<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="white">
        <div class="overflow-y-auto" style="max-height: calc(100vh - 100px)">
            <div
                v-for="(event, index) in events"
                :key="index"
            >
                <table
                    style="border-spacing: 6px"
                >
                    <thead>
                        <tr>
                            <th style="width: 20px"></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="getShowContentTitle(event.type)">
                            <td style="vertical-align: top;">
                                <icon
                                    v-if="getEventIconData(event.type)"
                                    class-list="d-block"
                                    :icon="getEventIconData(event.type).icon"
                                    :color="getEventIconData(event.type).color"
                                    size="20"
                                />
                            </td>
                            <td class="calendar-event-text font-weight-medium">
                                {{ event.name }}
                            </td>
                        </tr>
                        <tr v-if="getPerson(event)">
                            <td style="vertical-align: top;">
                                <AccountAvatar
                                    size="20"
                                    text-color="neutral_n300"
                                    text-class="overline"
                                    item-class="d-flex"
                                    color="g3"
                                    :initials="getPerson(event).initials"
                                    :image-path="getPerson(event).avatar"
                                />
                            </td>
                            <td class="calendar-event-text">
                                {{ getPerson(event).name }}
                            </td>
                        </tr>
                        <tr v-if="getEventDates(event)">
                            <td style="vertical-align: top;">
                                <icon
                                    class-list="d-block"
                                    size="20"
                                    icon="CalendarDays"
                                />
                            </td>
                            <td class="calendar-event-text">
                                <span>
                                    {{ getEventDates(event) }}
                                </span>

                                <span v-if="getEventTimes(event)">
                                    {{ getEventTimes(event) }}
                                </span>
                            </td>
                        </tr>
                        <tr v-if="event.comment">
                            <td style="vertical-align: top;">
                                <icon
                                    class-list="d-block"
                                    size="20"
                                    icon="MessageSquare"
                                />
                            </td>
                            <td class="calendar-event-text">
                                {{ event.comment }}
                            </td>
                        </tr>
                        <tr v-if="event.link">
                            <td style="vertical-align: top;">
                                <icon
                                    class-list="d-block"
                                    size="20"
                                    icon="ExternalLink"
                                />
                            </td>
                            <td class="calendar-event-text">
                                <a :href="event.link" target="_blank">
                                    {{ event.link }}
                                </a>
                            </td>
                        </tr>
                        <tr v-if="event.supplier">
                            <td style="vertical-align: top;">
                                <router-link
                                    :to="getSupplierLink(event)"
                                    class="d-flex"
                                >
                                    <icon
                                        icon="HeartHandshake"
                                        :size="20"
                                    />
                                </router-link>
                            </td>
                            <td class="calendar-event-text">
                                <router-link
                                    :to="getSupplierLink(event)"
                                    class="main--text"
                                >
                                    {{ event.supplier.name }}
                                </router-link>
                            </td>
                        </tr>
                        <tr v-if="event.project">
                            <td style="vertical-align: top;">
                                <router-link
                                    :to="getProjectLink(event)"
                                    class="d-flex"
                                >
                                    <icon
                                        :color="event.project.color"
                                        icon="ClipboardList"
                                        :size="20"
                                    />
                                </router-link>
                            </td>
                            <td class="calendar-event-text">
                                <router-link
                                    :to="getProjectLink(event)"
                                    class="main--text"
                                >
                                    {{ event.project.name }}
                                </router-link>
                            </td>
                        </tr>
                        <tr v-if="event.client">
                            <td style="vertical-align: top;">
                                <router-link
                                    :to="getClientLink(event)"
                                    class="d-flex text-decoration-none"
                                >
                                    <ClientAvatar
                                        :color="event.client.color"
                                        :initials="event.client.initials"
                                        :size="20"
                                    />
                                </router-link>
                            </td>
                            <td class="calendar-event-text">
                                <router-link
                                    :to="getClientLink(event)"
                                    class="main--text"
                                >
                                    {{ event.client.name }}
                                </router-link>
                            </td>
                        </tr>
                        <tr v-if="getCompany(event)">
                            <td style="vertical-align: top;">
                                <icon
                                    class-list="d-block"
                                    size="20"
                                    icon="Briefcase"
                                />
                            </td>
                            <td class="calendar-event-text">
                                {{ getCompany(event).name }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <v-divider
                    v-if="index !== events.length - 1"
                    class="mt-2 mx-1"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import {computed, ref} from "@vue/composition-api";
import {
    parseSysDate,
    formatTime,
    parseSysDateTime,
    formatDate, formatSysTime
} from '../../plugins/formatting'
import { $t } from "@/i18n";
import { getInitials } from "@/modules/initials";

import UserModule from "@/store/modules/user";
import RightsModule from "@/composables/use-rights";
import AccountModule from "@/store/modules/account";
import AccountAvatar from "@/components/AccountAvatar.vue";
import {VACATION_CALENDAR_TYPE} from "@/modules/calendar/calendar";
import ClientAvatar from "@/components/ClientAvatar.vue";

export default {
    name: "CalendarEventContent",
    components: {ClientAvatar, AccountAvatar},
    props: {
        calendarEvent: {
            type: Object,
            required: true
        }
    },
    setup(props, ctx) {
        const { can_edit_account } = RightsModule();
        const { visibleMembers } = UserModule();
        const { getAccount } = AccountModule();

        const getEventIconData = (eventType) => {
            if (['contact_birthday', 'member_birthday'].includes(eventType)) {
                return {
                    color: 'pink',
                    icon: 'Cake'
                }
            } else if (eventType === 'company_event') {
                return {
                    color: 'royal-blue',
                    icon: 'Megaphone'
                }
            } else if (eventType === VACATION_CALENDAR_TYPE.VACATION) {
                return {
                    color: 'brown',
                    icon: 'Palmtree'
                }
            } else if (eventType === VACATION_CALENDAR_TYPE.FLEXTIME_VACATION) {
                return {
                    color: 'brown',
                    icon: 'Clock'
                }
            } else if (eventType === VACATION_CALENDAR_TYPE.SICK_LEAVE) {
                return {
                    color: 'brown',
                    icon: 'Frown'
                }
            } else if (eventType === VACATION_CALENDAR_TYPE.PARENTAL_LEAVE) {
                return {
                    color: 'brown',
                    icon: 'Baby'
                }
            } else if (Object.values(VACATION_CALENDAR_TYPE).includes(eventType)) {
                return {
                    color: 'brown',
                    icon: 'Footprints'
                }
            } else if (eventType === 'article') {
                return {
                    color: 'n4',
                    icon: 'AlignLeft'
                }
            } else if (eventType === 'article') {
                return {
                    color: 'n4',
                    icon: 'GraduationCap'
                }
            }

            return null
        }

        const getPerson = (event) => {
            if (!event.person_id) {
                return null
            }

            let account = visibleMembers.value.find(x => {
                if (Array.isArray(x.id)) {
                    return x.id.includes(event.person_id)
                } else {
                    return x.id === event.person_id
                }
            })

            if (!account) {
                return null
            }

            return account
        }

        const getEventDates = (event) => {
            if (!event.date_from || !event.date_until) {
                return null
            }

            let dateFromFormatted = formatDate(event.date_from)
            let dateUntilCalculated = parseSysDateTime(event.date_until)

            dateUntilCalculated.setSeconds(dateUntilCalculated.getSeconds() - 1)
            let dateUntilFormatted = formatDate(dateUntilCalculated)

            if (dateFromFormatted === dateUntilFormatted) {
                return dateFromFormatted
            }

            return dateFromFormatted + ' - ' + dateUntilFormatted
        }

        const getEventTimes = (event) => {
            if (!event.date_from || !event.date_until) {
                return null
            }

            let sysTimeFrom = formatSysTime(parseSysDateTime(event.date_from))
            let sysTimeUntil = formatSysTime(parseSysDateTime(event.date_until))
            let dateFromFormatted = formatTime(event.date_from)
            let dateUntilFormatted = formatTime(event.date_until)

            if (sysTimeFrom === '00:00:00' && sysTimeUntil === '00:00:00') {
                return null
            }

            return '@ ' + dateFromFormatted + ' - ' + dateUntilFormatted
        }

        const getCompany = (event) => {
            return event.company_id ? getAccount(event.company_id).value : null
        }

        const isGrouped = computed(() => {
            return Boolean(props.calendarEvent.events)
        })

        const events = computed(() => {
            return props.calendarEvent.events ? props.calendarEvent.events : [props.calendarEvent]
        })

        const getClientLink = (event) => {
            return {
                name: 'client_profile_overview',
                params: {
                    id: event.client.id
                }
            }
        }

        const getProjectLink = (event) => {
            return {
                name: 'project_communication',
                params: {
                    id: event.project.id
                }
            }
        }

        const getSupplierLink = (event) => {
            return {
                name: 'supplier',
                params: {
                    id: event.supplier.id
                }
            }
        }

        const getShowContentTitle = (eventType) => {
            return isGrouped.value || ['member_birthday', 'contact_birthday'].includes(eventType)
        }

        return {
            can_edit_account,
            getInitials,
            getEventIconData,
            events,
            getCompany,
            getEventDates,
            getEventTimes,
            getPerson,
            isGrouped,
            getClientLink,
            getProjectLink,
            getSupplierLink,
            getShowContentTitle
        };
    }
};
</script>

<style scoped lang="scss">
.calendar-event-text {
    font-size: 12px;
    line-height: 16px;
}
</style>